
import { CREATE_FORMULA, FETCH_CALCULATIONS, CREATE_TREATMENT, FETCH_TREATMENT, DELETE_CALCULATORS, DELETE_TREATMENTS, SHOW_CALC, FETCH_CALCULATIONS_BY_TYPE, SHOW_TREATMENT, UPDATE_CALCULATOR,TOTAL_PENDING_TREATMENTS,TOTAL_ONGOING_TREATMENTS,UPDATE_TREATMENT } from '../actions';
import { NotificationManager } from 'react-notifications';
const initialState = {
    calculatorsToDelete: null,
    treatmentsToDelete: null,
    setCalculations: null,
    setTreatments: null,
    treatment: [],
    calculations: [],
    calculationByType: [],
    loading: false,
    showCal: '',
    showTreatment: '',
    updatedCalculator: '',
    pendingTreatCount:0,
    ongoingTreatCount:0,
    setCalculationsError:null,
    calculationsError:null,
    setTreatmentsError:null,
    ongoingTreatCountError:null,
    pendingTreatCountError:null,
    treatmentError:null,
    calculationByTypeError:null,
    calculatorsToDeleteError:null,
    treatmentsToDeleteError:null,
    showCalError:null,
    showTreatmentError:null,
    updatedCalculatorError:null,
    updatedTreatment:null,
};

function addFormulaReducer(state = initialState, action) {
  let 
    calculatorsToDelete,
    treatmentsToDelete,
    setCalculations,
    setTreatments,
    treatment,
    calculations,
    calculationByType,
    showCal,
    showTreatment,
    pendingTreatCount,
    ongoingTreatCount,
    updatedCalculator,
    updatedTreatment;

  switch (action.type) {
    case `${CREATE_FORMULA}_PENDING`:
    case `${FETCH_CALCULATIONS}_PENDING`:
    case `${CREATE_TREATMENT}_PENDING`:
    case `${FETCH_TREATMENT}_PENDING`:
    case `${DELETE_CALCULATORS}_PENDING`:
    case `${DELETE_TREATMENTS}_PENDING`:
    case `${SHOW_CALC}_PENDING`:
    case `${SHOW_TREATMENT}_PENDING`:
    case `${FETCH_CALCULATIONS_BY_TYPE}_PENDING`:
    case `${UPDATE_CALCULATOR}_PENDING`:
    case `${TOTAL_ONGOING_TREATMENTS}_PENDING`:
    case `${TOTAL_PENDING_TREATMENTS}_PENDING`:
    case `${UPDATE_TREATMENT}_PENDING` :
      return { ...state, loading: true };

    case `${CREATE_FORMULA}_FULFILLED`:
    setCalculations = action.payload.data;
      return { ...state, loading: false, setCalculations };

    case `${FETCH_CALCULATIONS}_FULFILLED`:
    calculations = action.payload.data;
      return { ...state, loading: false, calculations };

    case `${CREATE_TREATMENT}_FULFILLED`:
    setTreatments = action.payload.data;
        return { ...state, loading: false, setTreatments };
    case `${TOTAL_ONGOING_TREATMENTS}_FULFILLED`:
    ongoingTreatCount = action.payload.data;
        return { ...state, loading: false, ongoingTreatCount };
    case `${TOTAL_PENDING_TREATMENTS}_FULFILLED`:
    pendingTreatCount = action.payload.data;
        return { ...state, loading: false, pendingTreatCount };

    case `${FETCH_TREATMENT}_FULFILLED`:
    treatment = action.payload.data;
        return { ...state, loading: false, treatment };

    case `${FETCH_CALCULATIONS_BY_TYPE}_FULFILLED`:
    calculationByType = action.payload.data;
        return { ...state, loading: false, calculationByType }

    case `${DELETE_CALCULATORS}_FULFILLED`:
    calculatorsToDelete = action.payload.data;
        return { ...state, loading: false, calculatorsToDelete };

    case `${DELETE_TREATMENTS}_FULFILLED`:
    treatmentsToDelete = action.payload.data;
        return { ...state, loading: false, treatmentsToDelete };

    case `${SHOW_CALC}_FULFILLED`:
    showCal = action.payload.data;
      return { ...state, loading: false, showCal };

    case `${SHOW_TREATMENT}_FULFILLED`:
    showTreatment = action.payload.data;
        return { ...state, loading: false, showTreatment };

    case `${UPDATE_CALCULATOR}_FULFILLED`:
    updatedCalculator = action.payload.data;
        return { ...state, loading: false, updatedCalculator };

    case `${UPDATE_TREATMENT}_FULFILLED`:
            updatedTreatment = action.payload.data;    
                return { ...state, loading: false, updatedTreatment };

    case `${CREATE_FORMULA}_REJECTED`:
        state = initialState;
        return {...state, loading: false, setCalculationsError: `${action.payload.message}`, ...state };
    case `${FETCH_CALCULATIONS}_REJECTED`:
        state = initialState;
        return {...state, loading: false, calculationsError: `${action.payload.message}`, ...state };
    
    case `${CREATE_TREATMENT}_REJECTED`:
        state = initialState;
        return {...state, loading: false, setTreatmentsError: `${action.payload.message}`, ...state };
    case `${FETCH_TREATMENT}_REJECTED`:
        state = initialState;
        return {...state, loading: false, treatmentError: `${action.payload.message}`, ...state };
    case `${DELETE_CALCULATORS}_REJECTED`:
        state = initialState;
        return {...state, loading: false, calculatorsToDeleteError: `${action.payload.message}`, ...state };
    case `${DELETE_TREATMENTS}_REJECTED`:
        state = initialState;
        return {...state, loading: false, treatmentsToDeleteError: `${action.payload.message}`, ...state };
    case `${SHOW_CALC}_REJECTED`:
        state = initialState;
        return {...state, loading: false, showCalError: `${action.payload.message}`, ...state };
    case `${SHOW_TREATMENT}_REJECTED`:
        state = initialState;
        return { loading: false, showTreatmentError: `${action.payload.message}`, ...state };
    case `${FETCH_CALCULATIONS_BY_TYPE}_REJECTED`:
        state = initialState;
        return { loading: false, calculationByTypeError: `${action.payload.message}`, ...state };
    case `${UPDATE_CALCULATOR}_REJECTED`:
        state = initialState;
        return { loading: false, updatedCalculatorError: `${action.payload.message}`, ...state };
    case `${TOTAL_ONGOING_TREATMENTS}_REJECTED`:
        state = initialState;
        return { loading: false, ongoingTreatCountError: `${action.payload.message}`, ...state };
    case `${TOTAL_PENDING_TREATMENTS}_REJECTED`:
        state = initialState;
        return { loading: false, pendingTreatCountError: `${action.payload.message}`, ...state };
    case `${UPDATE_TREATMENT}_REJECTED`:
        state = initialState;
        return { loading: false, updateTreatmentError: `${action.payload.message}`, ...state };
    default:
      return state;
  }
}

export default addFormulaReducer;
